import React from 'react';
import email from '../assets/email.svg'
import voltar from '../assets/voltar.svg'
import { useFormik } from 'formik';

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Campo obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Digite um email válido';
  }
  return errors;
};

export default function ForgotPass({ history }) {

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validate,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: values => {
      console.log(values);
    },
  });

  function handleLogin(event) {
    event.preventDefault();
    history.push('login')
  }

  return (
    <>
      <div className='container login d-flex flex-column align-items-center bg-light'>
        <a className="navbar-brand pb-2 socialLogos voltar" onClick={event => handleLogin(event)} href='.' >
          <img className="mb-3" src={voltar} alt="logo" width="24" height="24" />
        </a>
        <h4 className='mb-4 text-center'>Recuperação de Senha</h4>
        <form className='form' onSubmit={formik.handleSubmit}>

          <div className="input-group input-group mb-4 mr-sm-2">
            <div className="input-group-prepend">
              <div className={formik.errors.email ? "input-group-text borderRed" : "input-group-text"}>
                <img className="" src={email} alt="logo" width="18" height="18" />
              </div>
            </div>
            <input
              className={formik.errors.email ? "form-control borderRed" : "form-control"}
              id="email"
              name="email"
              placeholder='Seu email'
              onChange={formik.handleChange}
              value={formik.values.email}
            />
            {formik.errors.email ? <div className='invalid'>{formik.errors.email}</div> : null}
          </div>

          <button className="btn btn-outline-dark btn-block w-100 mb-2" type="submit">Recuperar</button>

        </form>
      </div>
    </>
  );
}